import { Diffuseur } from '../../../../models/diffuseur';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil, map, first } from 'rxjs/operators';
import { InformationComponent } from '../../../shared/modals/information/information.component';
import { PreferenceMessages } from '../../../shared/models/component-messages/preference-messages';
import { PreferenceDiffuseurTableau } from '../model/preference-diffuseur';
import { PreferencesService } from '../services/preferences.service';
import { DepartementMapper } from '../../../../models/enums/zone-geographique.enum';
import { Title } from '@angular/platform-browser';
import { AuthorizationService } from '../../../../authorization/services/authorization.service';
import { EnumMicroDroits } from '../../../administration/models/micro.droits';
@Component({
  selector: 'app-preferences-liste-diffusion',
  templateUrl: './preferences-liste-diffusion.component.html',
  styleUrls: ['./preferences-liste-diffusion.component.scss']
})
export class PreferencesListeDiffusionComponent implements OnInit {

  public preferenceMessages = new PreferenceMessages();

  private unsubscribe$ = new Subject<void>();

  allDatasDiffuseurs: Diffuseur[] = [];

  diffuseurTableau: PreferenceDiffuseurTableau[] = [];

  isGestionComptesAnnonceur: boolean;

  constructor(private preferenceService: PreferencesService, private modalService: NgbModal, private router: Router,
    private titleService:Title, private authorizationService: AuthorizationService) { }

  ngOnInit(): void {
    this.getAllDiffuseurs();
    this.titleService.setTitle('Avis de publicité - Préférences');
    this.habilitations();

  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  createList(): void {
    this.router.navigate([location.pathname + '/pref-diffuseur']);
  }

  getAllDiffuseurs(): void {
    this.preferenceService.getAllDatasDiffuseurs().pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          this.allDatasDiffuseurs = data;
          this.getPref();
        })
      });
  }

  getPref(): void {
    this.preferenceService.getFullDiffuseur().pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          this.diffuseurTableau = [];
          data.forEach(el => {
            const diffTab = new PreferenceDiffuseurTableau();
            diffTab.id = el.id;
            diffTab.titre = el.titre;
            diffTab.compteur = el.content.values.length;
            let diffuseurs: Diffuseur[] = new Array();
            for (let index = 0; index < el.content.values.length; index++) {
              const val = el.content.values[index];
                const diff: Diffuseur = this.allDatasDiffuseurs?.find(element => element.id === Number(val.value));
                diffuseurs.push(diff);

            }
            diffTab.diffuseurs = diffuseurs;
            this.diffuseurTableau?.push(diffTab);
          })
        })
      });
  }

  update(item: PreferenceDiffuseurTableau): void {
    this.router.navigate([location.pathname + '/pref-diffuseur/' + item.id]);
  }

  delete(item: PreferenceDiffuseurTableau): void {

    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.title = '';
    modalRef.componentInstance.content = this.preferenceMessages.modal_delete_text;
    modalRef.componentInstance.OkOuRetour = true;
    modalRef.dismissed.pipe(map((reason: boolean) => {
      return reason;
    }))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((reason) => {
          if (reason) {
            this.preferenceService.deleteDiffuseur(item.id)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe({
                next: (() => {
                  this.getPref();
                })
              });
          }
        })
      })
  }

  textSupport(item: any): string {
    let res: string = "";
    res = res.concat("• ")
    if (item?.typeFlux !== "PRESSE_SPE") {
      res = res.concat(item?.support !== "" ? item?.support : String(item?.typeZone))
      if (String(item?.typeSupport) != "AUCUN") {
        res = res.concat(" - " + String(item?.typeSupport))
      }
    } else {
      res = res.concat(item?.intitule);
    }
    return res;
  }

  getZoneGeo(item: Diffuseur): string {
    return DepartementMapper.getIntitule(String(item?.zoneGeographique))
  }

  get sortList() {
    return this.diffuseurTableau.sort((a, b) => {
      return <any>new Date(b.dateCreation) - <any>new Date(a.dateCreation);
    });
  }

  isDiffuseurJOUEBOAMP (diffuseur: any) : boolean {
    if(diffuseur?.typeFlux ==='JOUE' || diffuseur?.typeFlux ==='BOAMP') {
      return true;
    }
    return false;
  }

  private habilitations() {
    this.authorizationService.hasAnyMicroRightIn([EnumMicroDroits.COMPTES_ANNONCEURS_GESTION])
      .pipe(first())
      .subscribe(isGestionComptesAnnonceur => { this.isGestionComptesAnnonceur = isGestionComptesAnnonceur });
  }
}
